import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";

// Variável global para armazenar a instância do STOMP
let stompClient = null;
const urlWebSocket = "http://localhost:8081/ws";

export default {
  namespaced: true,
  state() {
    return {
      isConnected: false, // Apenas controla se está conectado
    };
  },
  mutations: {
    setConnected(state, isConnected) {
      state.isConnected = isConnected;
    },
  },
  actions: {
    connectStompClient({ commit }) {
      console.log('1');
      if (stompClient !== null && stompClient.connected) {
        console.log("🟢 WebSocket já conectado");
        return;
      }
      console.log('2');
      const token = JSON.parse(localStorage.getItem("mizunetoken"));
      if (!token) {
        console.error("❌ Token não encontrado");
        return;
      }
      console.log('3');

      const socket = new SockJS(urlWebSocket, null, {withCredentials: true});

      console.log('4');
      stompClient = new Client({
        webSocketFactory: () => socket,
        reconnectDelay: 5000,
        connectHeaders: {
          Authorization: token,
        },
        onConnect: () => {
          console.log("✅ Conectado ao WebSocket");
          commit("setConnected", true);
        },
        onDisconnect: () => {
          console.log("❌ Desconectado do WebSocket");
          commit("setConnected", false);
        },
      });

      console.log('5');

      stompClient.activate();
    },

    disconnectStompClient({ commit }) {
      if (stompClient !== null) {
        stompClient.deactivate();
        commit("setConnected", false);
        console.log("❌ WebSocket desconectado");
      }
    },
  },
  getters: {
    isConnected(state) {
      return state.isConnected;
    },
    getStompClient() {
      return stompClient;
    },
  },
};
